import React from 'react';

const useWindowScroll = () => {
  const [offset, setOffset] = React.useState(0);

  const update = () => {
    setOffset(window.pageYOffset);
  };

  React.useEffect(() => {
    window.addEventListener('scroll', update);
    return () => window.removeEventListener('scroll', update);
  }, []);

  return offset;
};

export default useWindowScroll;
